import React from 'react';
import { formatCash } from '../../utils/sharedFunctions.js';
import './style.scss';

const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
const ProfessionalCard = ({ item, handleViewUser, style, id }) => {
  
  const getFreelanceLabel = () => {
    const accType = item?.accountType;
    if (accType === 'personal' ||accType === "professional") return 'Independent Contractor';
    if (accType === 'company' || accType ==='business' ) return 'Business';
    return 'Not Assigned';
  };

  const totalProjects = (item?.briefs?.length ?? 0) + (item?.projects?.length ?? 0);
  const location = `${item?.state ?? ''} - ${item?.city ?? ''}` || 'Not Assigned';

  return (
    <div className='availProfessionalCard_' onClick={() => handleViewUser(item?._id ?? '')} style={style}>
      <div className='professionalProfileDetails'>
        <div className='profilePic'>
          <img src={UserIcon} alt='User Icon' style={{ width: '100%', height: '100%' }} />
        </div>
        <div className='userINfo'>
          <p className='userFullName'>{`${item?.firstName ?? ''} ${item?.lastName ?? ''}`}</p>
          <p className='useremail' style={{ margin: '1px', color: '#AFAFAF' }}>{item?.email ?? ''}</p>
          <p className='userFullName' style={{ fontSize: '14px' }}>{getFreelanceLabel()}</p>
        </div>
      </div>
      {id === 'addpro' ?
        <div className='professionalRoleDeatils' style={{ flexWrap: "nowrap", width: '100%', justifyContent: 'flex-start', height: '72%' }}>
          <div className='professionalValuesSect' style={{  width: "90%", minHeight: "10%",height:"auto",  overflow: 'hidden' }}>
            <p className='placeholdeer'>Professional skills</p>

            {Array.isArray(item?.professional?.designAndIllustration?.services) ?
              item?.professional?.designAndIllustration?.services.map((item, index) => {

                return (
                  <ul key={index} style={{ margin: '0px', width: '40%', overflow: 'hidden', display: "flex", flexDirection: "column", flexWrap: "wrap" }}>
                    <li>{item}</li>
                  </ul>
                )
              }) : <p>Not Assigned</p>
            }

          </div>
          <div style={{ display: "flex", height:'30%',  flexDirection: "row", width: "100%" }}>
            <div className='professionalValuesSect' style={{ display: "flex",height:"85%", flexDirection: "column" }}>
              <p className='placeholdeer'>Total Projects</p>
              <p className='value'>{item?.jobCount}</p>
            </div>
            <div className='professionalValuesSect' style={{ display: "flex",height:"85%", flexDirection: "column" }}>
              <p className='placeholdeer'>Location</p>
              <p className='value'>{location}</p>
            </div>
          </div>
          <div style={{ display: "flex", height:'30%',  flexDirection: "row", width: "100%" }}>

            <div className='professionalValuesSect' style={{ display: "flex",height:"85%", flexDirection: "column" }}>
              <p className='placeholdeer'>Gender</p>
              <p className='value'>{item?.professional?.gender ?? ""}</p>
            </div>
            <div className='professionalValuesSect' style={{ display: "flex",height:"85%", flexDirection: "column" }}>
              <p className='placeholdeer'>Credipple Rating</p>
              <p className='value'>{item?.averageRating ?? 'N/A'}</p>
            </div>
          </div>
        </div>
        :
        <div className='professionalRoleDeatils'>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Daily Rate</p>
            <p className='value'>{`ZAR  ${formatCash(item?.professional?.ratePerDay ?? 0)}`}</p>
          </div>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Total Projects</p>
            <p className='value'>{item?.jobCount}</p>
          </div>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Location</p>
            <p className='value'>{location}</p>
          </div>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Service Category</p>
            <p className='value'>{item?.professional?.services ?? ''}</p>
          </div>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Gender</p>
            <p className='value'>{item?.professional?.gender ?? ""}</p>
          </div>
          <div className='professionalValuesSect'>
            <p className='placeholdeer'>Credipple Rating</p>
            <p className='value'>{item?.averageRating ?? 'N/A'}</p>
          </div>
        </div>
      }

    </div>
  );
};

export default ProfessionalCard;
